import React from 'react';
import { InlineNotification, TextInput } from 'carbon-components-react';
import { StripePaymentCard, PricingSummary } from 'components/PremiumWizard';
import { AuthorisationType } from '../TransactionTypeStep';

const TRANSACTION_TYPE_LABELS: Record<AuthorisationType, string> = {
  WEB_ENQUIRY_AUTOMATION: 'Web flow enquiry lodgement',
  CREATE_ENQUIRY: 'API transactions'
};

interface Props {
  authorisationType: AuthorisationType;
  quantity: number;
  pricePerTransaction: number;
  priceIncludeTax: boolean;
  purchaseOrderNumber: string;
  onPurchaseOrderNumberChange: (purchaseOrderNumber: string) => void;
}

const InvoicePayment: React.FC<Props> = ({
  authorisationType,
  quantity,
  pricePerTransaction,
  priceIncludeTax,
  purchaseOrderNumber,
  onPurchaseOrderNumberChange
}) => {
  const totalPrice = (quantity * pricePerTransaction).toFixed(2);
  const transactionTypeLabel = TRANSACTION_TYPE_LABELS[authorisationType];

  return (
    <div className="invoice-payment">
      {/* Invoice section */}
      <div className="invoice-payment--section">
        <div className="invoice-payment--section-heading">Invoice</div>

        <InlineNotification
          kind="info"
          lowContrast={true}
          title=""
          subtitle="Your account is authorised for post-payment. An invoice will be sent to your registered email upon confirmation."
          hideCloseButton={true}
          className="invoice-payment--notification"
        />

        <StripePaymentCard
          amount={`$${totalPrice}`}
          currency="AUD"
          description="Purchase transaction · One-time · Invoice"
        />
      </div>

      <div className="invoice-payment--input">
        <TextInput
          id="purchase-order-number"
          labelText="Purchase order number (optional)"
          placeholder="Max 255 characters"
          maxLength={255}
          value={purchaseOrderNumber}
          onChange={(event) => onPurchaseOrderNumberChange(event.target.value)}
        />
      </div>

      {/* Invoice summary section */}
      <div className="invoice-payment--section">
        <div className="invoice-payment--section-heading">Invoice summary</div>

        <PricingSummary
          lineItems={[
            {
              label: transactionTypeLabel,
              amount: `$${totalPrice}`,
              isHighlighted: true
            }
          ]}
          total={{
            label: 'Total',
            amount: `$${totalPrice} AUD${priceIncludeTax ? ' (inc. GST)' : ''}`
          }}
          showHeader={true}
          variant="payment"
        />
      </div>
    </div>
  );
};

export default InvoicePayment;
